import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';

export class GradeIcon extends Component {
  getIcon() {
    let icon;
    const { emojis, grade, size } = this.props;

    if (grade > 90) {
      icon = emojis.emojiExcellentActive;
    } else if (grade > 60) {
      icon = emojis.emojiGoodActive;
    } else if (grade > 40) {
      icon = emojis.emojiAcceptableActive;
    } else if (grade) {
      icon = emojis.emojiPoorActive;
    } else {
      icon = emojis.emojiVeryPoorActive;
    }

    return <img src={icon} alt={icon} style={size ? { width: size, height: size } : undefined} />;
  }

  getGradeMark() {
    let gradeMark = '';
    const { grade } = this.props;

    if (grade > 90) {
      gradeMark = I18n.t('tasks.gradeIcon.excellent');
    } else if (grade > 60) {
      gradeMark = I18n.t('tasks.gradeIcon.good');
    } else if (grade > 40) {
      gradeMark = I18n.t('tasks.gradeIcon.acceptable');
    } else if (grade) {
      gradeMark = I18n.t('tasks.gradeIcon.poor');
    } else {
      gradeMark = I18n.t('tasks.gradeIcon.veryPoor');
    }

    return <span>{gradeMark}</span>;
  }

  render() {
    const { active, notShowText } = this.props;

    return (
      <div className={`grade-info ${active ? 'selected' : ''}`}>
        {this.getIcon()}
        {!notShowText ? this.getGradeMark() : null}
      </div>
    );
  }
}

GradeIcon.propTypes = {
  size: PropTypes.number,
  grade: PropTypes.number,
  emojis: PropTypes.object,
  active: PropTypes.bool,
  notShowText: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    emojis: state.theme.images.emojis
  };
}

export default connect(mapStateToProps)(GradeIcon);
